<template>
<div>
  <a-card v-if="pageLoading">
    <a-spin tip="Loading..." :spinning="pageLoading"
    ></a-spin> 
  </a-card>
    <a-form :form="form" v-else>
      <a-row :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Year">
            <a-select
              showSearch
              allowClear
              @change="handleYear"
              :disabled="mode=='Edit'"
              option-filter-prop="children"
              :filter-option="filterOptionYear"
              v-decorator="['year', {rules: [{required: true}], initialValue: initialData.header.year}]"
            >
              <a-select-option
                v-for="item in yearfield"
                :key="item.tahun"
              >{{item.tahun}}</a-select-option> 
            </a-select>
          </a-form-item>
          <a-form-item label="Simulation Name">
                <a-input
                  v-decorator="['simulation_nm', {rules: [{required: true}], initialValue: initialData.header.simulation_nm}]"
                ></a-input>
              </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Simulation Template's" v-if="id_template">
            <a-select
              showSearch
              allowClear
              @change="handleTemplate"
              :disabled="dischoicetemplate"
              option-filter-prop="children"
              :filter-option="filterOptionYear"
              :loading="templateLoading"
              v-decorator="['template_simulation', {rules: [{required: false}], initialValue: initialData.header.simulation_id}]"
            >
              <a-select-option
                v-for="item in templatefield"
                :key="item.id_simulasi"
              >{{item.jenis}} - {{item.nama}}</a-select-option> 
            </a-select>
          </a-form-item>
          <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['note', {initialValue: initialData.header.note}]"/>
        </a-form-item>
        </a-col>
      </a-row>
    </a-form>
</div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "HeaderSimulasi",
  props: {
    submitdata: {},
    data: {},
    mode: String,
    info: String,
    id_template: String,
    thn_template: String,
  },
  data() {
    return {
      pageLoading: true,
      yearfield:{},
      templatefield:{},
      dischoicetemplate: true,
      templateLoading: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
  },
  mounted(){
    //initial list year
    let now = new Date();
    let next = new Date(now.setFullYear(now.getFullYear() + 1));
    this.yearfield = [{tahun : next.getFullYear().toString()},{tahun : new Date().getFullYear().toString()}];

    this.fetchingData();

    if(this.id_template && this.thn_template){
      this.handleYear(this.thn_template)
      // this.$nextTick(function () {
      //     this.form.setFieldsValue({
      //         year: this.thn_template,
      //         template_simulation: this.id_template
      //     });
      //   });
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          header: {
            year:this.thn_template ? this.thn_template : undefined,
            simulation_nm:undefined,
            simulation_id: this.id_template ? this.id_template : undefined,
            note:undefined,
          }
        };
      } else {
        return {
          header:{
            year:this.data.year,
            simulation_nm:this.data.simulation_nm,
            simulation_id:this.data.template_simulation,
            note:this.data.note ? this.data.note : "",
          }
        };
      }
    },
  },
  methods: {
    moment,
    fetchingData() {
      const jenAngfield = axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/jenis_anggaran",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const tlcGAfield = axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/list_master",
        params: {
            job: "GA"
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const tlcAMfield = axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/list_master",
        params: {
            job: "AM"
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const depfield = axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/list_master",
        params: {
            job: "DEPT"
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      return axios
        .all([
          jenAngfield.catch(err => {
            console.log(err);
            return null;
          }),
          tlcGAfield.catch(err => {
            console.log(err);
            return null;
          }),
          tlcAMfield.catch(err => {
            console.log(err);
            return null;
          }),
          depfield.catch(err => {
            console.log(err);
            return null;
          }),
        ])
        .then(response => {
          if (response[0] !== undefined) {
            this.jenAngfield = response[0].data.data;
          } else {
            this.jenAngfield = [];
          }

          if (response[1] !== undefined) {
            this.tlcGAfield = response[1].data.list;
          } else {
            this.tlcGAfield = [];
          }

          if (response[2] !== undefined) {
            this.tlcAMfield = response[2].data.list;
          } else {
            this.tlcAMfield = [];
          }

          if (response[3] !== undefined) {
            this.depfield = response[3].data.list;
          } else {
            this.depfield = [];
          }
         

          this.pageLoading = false;
        })
        .catch(err => {
          console.log(err);
          // this.pageLoading = false;
        });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("headerform", {
          inputHeader: values
        });
       });
    },
    filterOptionYear(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleYear(val) {
      console.log(val)
      this.templateLoading = true
      this.templatefield = [];

      const templatefields = axios({
        method: "get",
        url: this.$serviceUrl + "simulasi/list_template",
        params: {
          tahun: val
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

       axios
        .all([
          templatefields.catch(err => {
            console.log(err);
            return null;
          }),
        ])
        .then(response => {
          if (response[0] !== undefined) {
            this.templatefield = response[0].data.list;
          } else {
            this.templatefield = [];
          }
          this.templateLoading = false;
          this.dischoicetemplate = false;
          
        })
        .catch(err => {
          this.templateLoading = false;
          this.dischoicetemplate = true;
          console.log(err);
          // this.pageLoading = false;
        });

        this.$nextTick(function () {
          this.form.setFieldsValue({
              template_simulation: null
          });
        });

      console.log(val);
    },
    handleTemplate(){

    }
  }
};
</script>

<style lang="less" scoped>
</style>